import React from "react";

import { VeBox, VeTypography } from "@packages/ui/mui";

import "./userFooter.scss";
import { useData } from "@providers/context";

const StickyFooter: React.FC = () => {
  const { configData } = useData();
  const CURRENT_YEAR = new Date().getFullYear();
  
  return (
    <VeBox className="footerstyles" bottom={0}>
      <VeBox
        marginX="2.5rem"
        className="element-max-width"
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <VeBox className="stickyFtrBox">
          <VeTypography variant="label3Disabled">
            &copy; {CURRENT_YEAR}
            <a
              className="stickyFtrLink"
              target="_blank"
              rel="noreferrer noopener"
              href={
                configData?.configurations?.find(
                  (item: any) => item?.key === "LANDING_PAGE",
                )?.value
              }
            >
              Vericap Pte Ltd.
            </a>
            All rights reserved.
          </VeTypography>
        </VeBox>
        <VeBox className="stickyFtrBox">
          <VeTypography variant="label3Disabled" marginX="2rem">
            <a
              className="stickyFtrLink"
              href={
                configData?.configurations?.find(
                  (item: any) => item?.key === "PRIVACY_POLICY",
                )?.value
              }
              target="_blank"
              rel="noreferrer"
            >
              Privacy policy
            </a>
          </VeTypography>
          <VeTypography variant="label3Disabled">
            <a
              href={
                configData?.configurations?.find(
                  (item: any) => item?.key === "TERMS_&_CONDITIONS",
                )?.value
              }
              target="_blank"
              rel="noreferrer"
              className="stickyFtrLink"
            >
              Terms & Conditions
            </a>
          </VeTypography>
        </VeBox>
      </VeBox>
    </VeBox>
  );
};

export default StickyFooter;
